"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideBreadcrumbsInsideList = exports.showBreadcrumbsInsideList = exports.moveBreadcrumbsInsideList = void 0;
var $breadcrumbsContainer = $('.filterable-list-breadcrumbs');
var $breadcrumbs = $('.breadcrumbs');
var moveBreadcrumbsInsideList = function (cssClass) {
    if (cssClass === void 0) { cssClass = '.list__wrapper'; }
    var $list = $(cssClass);
    $breadcrumbs.remove();
    $list.prepend($breadcrumbsContainer.attr({ class: 'row breadcrumbs' }));
};
exports.moveBreadcrumbsInsideList = moveBreadcrumbsInsideList;
var showBreadcrumbsInsideList = function () {
    $breadcrumbsContainer.show();
};
exports.showBreadcrumbsInsideList = showBreadcrumbsInsideList;
var hideBreadcrumbsInsideList = function () {
    $breadcrumbsContainer.hide();
};
exports.hideBreadcrumbsInsideList = hideBreadcrumbsInsideList;
